import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Stock } from '../../interface/stock/stock';
// import { StockComponent } from 'src/app/modules/admin/pages/stock/stock.component';
import { HttpService } from '../http/http.service';
import { firstValueFrom } from 'rxjs';
import { RawStock } from '../../interface/raw-stock';

@Injectable({
  providedIn: 'root'
})
export class StockService {

  constructor(private _httpService: HttpService) { }
  public getAll(query:string|null=null): Promise<any> {
    return firstValueFrom(this._httpService.get('/Stocks?'+(query??'')));
  }
  public getBySeller(id:number): Promise<any> {
    return firstValueFrom(this._httpService.get('/Stocks/Sellers/'+id+'?size=-1'));
  }
  public getRawStocks(): Promise<RawStock[]> {
    return firstValueFrom(this._httpService.get('/RawStocks')).then((x: RawStock[]) => x.filter(s => s.quantity > 0));
  }
  public getLowStock(): Promise<Stock[]> {
    return firstValueFrom(this._httpService.get('/Stocks/LowStock'));
  }
  //   sendStockRecord(data:Stock){
  //     return this._httpService.post('/Stocks',data);
  //   }
  //   updateStockRecord(id:number,data:Stock){
  //     return this._httpService.patch('/Stocks/',id,data);
  //   }
  //   deleteStockRecord(id:number){
  //     return this._httpService.delete('/Stocks/',id);
  // }
}
